module.exports = __webpack_public_path__ + "img/notfound_hero.a3f635a9.jpg";